import {CSSProperties} from 'typestyle/lib/types';

export const mixinBackgroundCover: CSSProperties = {
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat'
};

export const mixinPositionAbsoluteFill: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};